export const environment = {
  production: true,
  apiUrl: 'https://panel-cte.inaem.gob.es/api/v1/',
  baseUrl: 'https://panel-cte.inaem.gob.es/',
  apiKeyMap: 'AIzaSyABNf-IQEYMiot3cFI_Ele5uW8ig8DW8FA',
  paymentsUrl: 'http://walleq.io/',
  auth: {
    clientSecret: 'xGbAhWL960HycCoboFNvKdhpWJxnLdxIs55Gjn95',
    clientId: '2'
  }
};
